import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class OfferMarketRestrictions {
  constructor($scope, $rootScope, OfferMarketRestrictionService, UserService) {
    $scope.tabs = ['Country',
      'Group',
      'Member',
      'Product/Member',
      'Product/Country'
    ];
    
    $scope.check_member_restrictions = function() {
      _.each($scope.offer.member_restrictions, function(c) {
        c.checked = $scope.select_all;
      });
    };
    
    $scope.delete_member_restrictions = function() {
      var member_restrictions = _.where($scope.offer.member_restrictions, {
        checked: true
      });
      if (member_restrictions.length === 0) {
        alert('Please select at least one member restriction!');
        return;
      }
      
      if (confirm('Are you sure you want to delete these member restrictions?')) {
        member_restrictions = _.pluck(member_restrictions , 'id');
        OfferMarketRestrictionService.delete_member_restrictions(member_restrictions).then(function(data) {
          if (data.success) {
            $scope.offer.member_restrictions = _.filter($scope.offer.member_restrictions, (v) => _.indexOf(member_restrictions, v.id) === -1);
            $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
              type: 'counter',
              value: data.offer_restrictions_count
            }, null]]);
          }
        });
      }
    };

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.get_selected_tab = function() {
      return $scope.selected_tab;
    };

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.select2_options = {
      containerCssClass: 'multiselect2',
      dropdownCssClas: 'multiselect2',
      width: '500px'
    };

    $scope.update_continent_countries = function(continent) {
      if (continent.title == 'EU Countries') {
        var europe = $scope.continents.filter(function( continent ) {
          return continent.title == 'Europe';
        });
        angular.forEach(continent.countries, function(country) {
          var eu_country = europe[0].countries.filter(function( europe_country ) {
            return europe_country.title == country.title;
          });
          eu_country[0].checked = continent.checked;
        });  
      }else {
        angular.forEach(continent.countries, function(country) {
          country.checked = continent.checked;
        });
      }
    };

    $scope.update_data = function() {
      $scope.offer.country_restrictions = [];
      angular.forEach(window.continents, function(continent) {
        angular.forEach(continent.countries, function(country) {
          if (country.checked)
            $scope.offer.country_restrictions.push(country.id);
        });
      });

      $scope.offer.group_restrictions = [];
      angular.forEach(window.groups, function(group) {
        if (group.checked)
          $scope.offer.group_restrictions.push(group.id);
      });
      
      
      $scope.offer.business_relation_restrictions = [];
      $scope.offer.business_relation_restrictions = _.pluck(_.where($scope.business_relations, {
        checked: true
      }), 'id');
    };

    $scope.update_restrictions = function() {
      $scope.updating = true;
      $scope.update_data();
      OfferMarketRestrictionService.update($scope.offer).then(function(data) {
        if (data.success) {
          $scope.updating = false;
          $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
            type: 'counter',
            value: data.offer_restrictions_count
          }, null]]);
        }
      });
    };

    $scope.set_user_company_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company(null, request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.dialog_member_restriction.member_id = ui.item.id;
          $scope.dialog_member_restriction.member_company = ui.item.value;
          $scope.$apply();
        }
      });
    };

    $scope.add_member_restriction = function() {
      $scope.dialog_member_restriction = angular.copy(window.member_restriction);
      $scope.user_company = '';
      $scope.open_dialog('offer_member_restriction_dialog');
    };

    $scope.edit_member_restriction = function(member_restriction) {
      $scope.dialog_member_restriction = member_restriction;
      $scope.user_company = '';
      $scope.open_dialog('offer_member_restriction_dialog');
    };

    $scope.delete_member_restriction = function(index) {
      if (confirm('Are you sure you want to delete this member restriction?')) {
        OfferMarketRestrictionService.delete_member_restriction($scope.offer.member_restrictions[index].id).then(function(data) {
          if (data.success) {
            $scope.offer.member_restrictions.splice(index, 1);
            $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
              type: 'counter',
              value: data.offer_restrictions_count
            }, null]]);
          }
        });
      }
    };

    $scope.save_member_restriction = function() {
      $scope.updating_member_restriction = true;
      OfferMarketRestrictionService.save_member_restriction($scope.dialog_member_restriction).then(function(data) {
        if (data.success) {
          $scope.updating_member_restriction = false;
          $.fancybox.close();
          $scope.offer.member_restrictions = data.offer_member_restrictions;
          $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
            type: 'counter',
            value: data.offer_restrictions_count
          }, null]]);
        }
      });
    };
    
    $scope.quick_search = function() {
      window.filter_table('table.data', $scope.quick_filter);
    };

    $scope.add_product_member_restrictions = function() {
      $scope.dialog_member_restriction = angular.copy(window.product_member_restrictions);
      $scope.user_company = '';
      $scope.open_dialog('offer_product_member_restriction_dialog');
    };

    $scope.save_product_member_restrictions = function() {
      if (!$scope.dialog_member_restriction.member_id || $scope.dialog_member_restriction.products.length === 0) {
        alert('Please select at least one product and member!');
        return false;
      }
      $scope.updating_member_restriction = true;
      OfferMarketRestrictionService.save_product_member_restrictions($scope.dialog_member_restriction).success(function(data) {
        if (data.success) {
          $scope.updating_member_restriction = false;
          $.fancybox.close();
          $scope.offer.product_member_restrictions = _.groupBy(data.offer_product_member_restrictions, 'product_id');
          $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
            type: 'counter',
            value: data.offer_restrictions_count
          }, null]]);
        }
      });
    };

    $scope.delete_product_member_restriction = function(restrictions, restriction) {
      if (confirm('Are you sure you want to delete this product/member restriction?')) {
        OfferMarketRestrictionService.delete_product_member_restriction($scope.offer.id, restriction.id).success(function(data) {
          if (data.success) {
            restrictions.splice(_.indexOf(restrictions, restriction), 1);
            $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
              type: 'counter',
              value: data.offer_restrictions_count
            }, null]]);
          }
        });
      }
    };

    $scope.add_product_country_restriction = function() {
      $scope.dialog_product_country_restrictions = angular.copy(window.product_country_restrictions);
      $scope.open_dialog('offer_product_country_restrictions_dialog');
    };

    $scope.save_product_country_restrictions = function() {
      if ($scope.countries.length === 0 || $scope.dialog_product_country_restrictions.products.length === 0) {
        alert('Please select at least one product and country!');
        return false;
      }
      $scope.updating_product_country_restrictions = true;
      _.each($scope.countries, function(country) {
        $scope.dialog_product_country_restrictions.countries.push(parseInt(country));
      });
      OfferMarketRestrictionService.save_product_country_restrictions($scope.dialog_product_country_restrictions).success(function(data) {
        if (data.success) {
          $scope.updating_product_country_restrictions = false;
          $.fancybox.close();
          $scope.offer.product_country_restrictions = _.groupBy(data.offer_product_country_restrictions, 'product_id');
          $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
            type: 'counter',
            value: data.offer_restrictions_count
          }, null]]);
        }
      });
    };

    $scope.delete_product_country_restriction = function(restrictions, restriction) {
      if (confirm('Are you sure you want to delete this product/country restriction?')) {
        OfferMarketRestrictionService.delete_product_country_restriction($scope.offer.id, restriction.id).success(function(data) {
          if (data.success) {
            restrictions.splice(_.indexOf(restrictions, restriction), 1);
            $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
              type: 'counter',
              value: data.offer_restrictions_count
            }, null]]);
          }
        });
      }
    };

    $scope.add_product = function(products, product) {
      if (product && !_.contains(products, product))
        products.push(product);
    };

    $scope.remove_product = function(products, product) {
      products.splice(_.indexOf(products, product), 1);
    };

    $scope.select2_options = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '600px'
    };

    $scope.$watch('continent', function() {
      $scope.countries = [];
      if ($scope.continent && $scope.continent !== '') {
        var group = $('select#countries').find('optgroup[label="' + $scope.continent + '"]');
        group.find('option').each(function() {
          $scope.countries.push($(this).attr('value'));
        });
      }
    });

    $scope.remove_all_country_restrictions = function() {
      _.each($scope.continents, function(continent) {
        _.each(continent.countries, function(country) {
          country.checked = false;
        });
      });
    };

    $scope.init = function() {
      $scope.business_relations = window.business_relations;
      $scope.selected_tab = 0;
      window.offer.product_country_restrictions = _.groupBy(window.offer.product_country_restrictions, 'product_id');
      window.offer.product_member_restrictions = _.groupBy(window.offer.product_member_restrictions, 'product_id');
      $scope.offer = window.offer;
      $scope.continents = window.continents;
      $scope.eu_countries = window.eu_countries;
      $scope.groups = window.groups;
      $scope.dialog_member_restriction = angular.copy(window.member_restriction);
      $scope.set_user_company_autocomplete($('input.user_company'));
    };

    $scope.init();
  }
}

OfferMarketRestrictions.$inject = ['$scope', '$rootScope', 'OfferMarketRestrictionService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-market-restrictions.ctrl.js